// Operations: retention, export/deletion (PRD §19–20). Metrics live outside the registry (/api/metrics, bearer token).
import * as O from './api-ops.js';
import { IdParam, route, W, Ws } from './route-def.js';

const T = 'operations';
const ContactParams = W({ contactId: IdParam });

export const opsRoutes = {
  getRetentionPolicy: route({
    method: 'GET', path: '/workspaces/:workspaceId/retention', summary: 'Política de retención de datos del espacio', tag: T,
    minRole: 'admin', params: Ws, response: O.RetentionSettingsSchema,
  }),
  updateRetentionPolicy: route({
    method: 'PUT', path: '/workspaces/:workspaceId/retention', summary: 'Actualizar la política de retención (auditado; bitácora ≥ 12 meses)', tag: T,
    minRole: 'admin', params: Ws, body: O.UpdateRetentionPolicySchema, response: O.RetentionSettingsSchema,
  }),
  retentionDryRun: route({
    method: 'GET', path: '/workspaces/:workspaceId/retention/dry-run', summary: 'Simulación: qué eliminaría o redactaría la siguiente ejecución, por categoría', tag: T,
    minRole: 'admin', params: Ws, response: O.RetentionDryRunSchema,
  }),
  exportContactData: route({
    method: 'GET', path: '/workspaces/:workspaceId/contacts/:contactId/export', summary: 'Exportar todos los datos de un contacto en JSON (descarga; auditado)', tag: T,
    minRole: 'admin', params: ContactParams, response: O.ContactExportSchema, produces: 'application/json',
  }),
  previewContactErasure: route({
    method: 'POST', path: '/workspaces/:workspaceId/contacts/:contactId/erasure/preview', summary: 'Paso 1: vista previa de la eliminación de datos de un contacto', tag: T,
    minRole: 'admin', params: ContactParams, response: O.ContactErasurePreviewSchema,
  }),
  eraseContact: route({
    method: 'POST', path: '/workspaces/:workspaceId/contacts/:contactId/erasure', summary: 'Paso 2: eliminar/anonimizar los datos personales del contacto (irreversible; auditado)', tag: T,
    minRole: 'admin', params: ContactParams, body: O.ContactErasureRequestSchema, response: O.ContactErasureResultSchema,
  }),
} as const;
